import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Alert } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';

const ScanResult = () => {
  const [itemData, setItemData] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // In a real app, this would parse the QR code data from the URL
    // For the prototype, we'll use mock data
    try {
      // Simulate getting data from URL query params
      const queryParams = new URLSearchParams(location.search);
      const encodedData = queryParams.get('data');
      
      if (encodedData) {
        // Decode and parse the data
        const decodedData = JSON.parse(decodeURIComponent(encodedData));
        setItemData(decodedData);
      } else {
        // For demo purposes, use mock data if no query param
        setItemData({
          item: "Laptop",
          contact: "john.doe@example.com",
          message: "This laptop belongs to John Doe. Please contact me if found."
        });
      }
    } catch (err) {
      setError("Could not read QR code data. The code might be invalid or damaged.");
    }
  }, [location]);

  if (error) {
    return (
      <Container className="py-5">
        <Alert variant="danger">
          <Alert.Heading>Error Reading QR Code</Alert.Heading>
          <p>{error}</p>
        </Alert>
      </Container>
    );
  }

  if (!itemData) {
    return (
      <Container className="py-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Card className="mx-auto" style={{ maxWidth: '600px' }}>
        <Card.Body className="text-center">
          <div className="display-1 mb-4">🔍</div>
          <Card.Title className="display-6">Found Item Information</Card.Title>
          
          <hr />
          
          <div className="my-4">
            <h5>Item</h5>
            <p className="lead">{itemData.item}</p>
            
            <h5 className="mt-4">Message from Owner</h5>
            <p>{itemData.message}</p>
            
            {itemData.contact && (
              <>
                <h5 className="mt-4">Contact Information</h5>
                <p>{itemData.contact}</p>
                
                <Button 
                  variant="primary" 
                  href={`mailto:${itemData.contact}`}
                  className="mt-2"
                >
                  Contact Owner
                </Button>
              </>
            )}
          </div>
          
          <div className="mt-5">
            <p className="text-muted small">
              This item is protected by QR Security Service.
            </p>
            <Link to="/" className="btn btn-link">Learn more about QR Security</Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ScanResult;